import { cn } from '@/lib/utils'
import { useRegistrationPipeline } from './useRegistrationPipeline'

export default function RegistrationBadge({ className }) {
  const { pending, loading } = useRegistrationPipeline()
  if (loading) return null
  if (pending.length === 0) return null

  return (
    <span className={cn(
      'inline-flex items-center justify-center min-w-[1.25rem] h-5 px-1.5',
      'text-xs font-semibold rounded-full bg-blue-600 text-white',
      className
    )}>
      {pending.length > 99 ? '99+' : pending.length}
    </span>
  )
}
